<template>
  <div class="w-full justify-between align-middle flex flex-wrap my-0 mx-auto
    text-[var(--color-white)] bg-[var(--color-black)]">
    <div class="ml-auto text-right py-4 flex-1 min-w-[300px] mr-24">
      <span>© Copyright 2026 | <a href="https://omind.de/" target="_blank" class="font-normal hover:text-[var(--color-orange)]">OMIND platform GmbH</a></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FooterComponent',
  methods: {
    openTerms() {
      if (this.$i18n.locale === 'de') {
        window.open('https://omindplatform-generic.azureedge.net/content/Datenschutzerkla%CC%88rung_de.pdf', '_blank');
      } else {
        window.open('https://omindplatform-generic.azureedge.net/content/PrivacyPolicy_en.pdf', '_blank');
      }
      window.open('https://omindplatform-generic.azureedge.net/content/2023_02_04_AGB_de.pdf', '_blank');
    },
  },
};
</script>
